module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"code":"Discount code","apply":"Apply","nonApplicable":"This discount code is non applicable"},"de":{"code":"Rabattcode","apply":"Anwenden","nonApplicable":"Dieser Rabattcode ist nicht anwendbar"}}')
  delete Component.options._Ctor
}
